import _ from 'lodash';
import {PREFIX, actionMeta} from './meta';
import URLService from 'service/URLService';
import {handleDefaultResponses} from 'service/StoreService';

const ty = actionMeta.identifiers;

const getInitState = () => {
    return  {
        currentTenantId: null,
        loginData: {}
    }
};

export default function reducer(state = getInitState(), action = "") {

    let newState = handleDefaultResponses(ty, state, action);

    if (action.type.startsWith(PREFIX)) {
        switch (action.type) {
            case ty.LOGIN_RESPONSE:
                state = {
                    ...newState,
                    loginData: action.payload.data
                }
                break;
            case ty.REQUEST_EMAIL_VERIFICATION_RESPONSE:
                state = {
                    ...newState,
                    registrationError: action.error
                }
                if(!action.error) {
                    // this should be pushed into the url, so we can refresh the page afterwards (and link to it)
                    URLService.setQueryParameter("email_code_sent", action.requestAction.payload.params.email);
                }
                break;
            case ty.REGISTRATION_RESPONSE:
                state = {
                    ...newState,
                    registrationError: action.error
                }
                if(!action.error) {
                    state = {
                        ...newState,
                        loginData: action.payload.data
                    }
                }
                break;
            case ty.REGISTRATION_RESET:
                state = {
                    ...newState,
                    registrationError: null
                }
                break;
            case ty.LOGOUT_RESPONSE:
                state = {
                    ...getInitState()
                }

                setTimeout(function() {
                    if(typeof window !== "undefined") {
                        window.location.reload();
                    }
                })

                break;
            case ty.SET_CURRENT_TENANT_ID:
                state = {
                    ...newState,
                    currentTenantId: action.payload.tenant_id
                }

                break;
            /*case ty.USERS_LIST_RESPONSE:
                state = {
                    ...state,
                    usersList: action.payload.data.users
                }

                break;*/
            default:
                return state
                break;
        }
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/storeState/auth/reducer.js